<script setup lang="ts">
const { t } = useI18n();
</script>

<template>
  <span class="block" role="status">
    <span
      class="motion-safe:animate-spin block size-full rounded-full scale-85 mix-blend-multiply"
      aria-hidden="true"
      :style="{
        background: 'conic-gradient(from 90deg, rgb(0, 94, 162) 0deg, white 360deg)',
        WebkitMaskImage: 'radial-gradient(farthest-side, transparent 60%, black 60%)',
        maskImage: 'radial-gradient(farthest-side, transparent 60%, black 60%)',
      }"
    />
    <span class="sr-only">{{ t("ui.loading") }}</span>
  </span>
</template>
